module.exports = __webpack_public_path__ + "img/icon_map_huanjingjiankong_zaixian_dianji.9b81f7dc.svg";